import { Component, OnInit } from '@angular/core';
import {StateService} from '../state.service';
import {User} from '../models/User';
import {AppService} from '../app.service';

@Component({
  selector: 'app-page3',
  templateUrl: './page3.component.html',
  styleUrls: ['./page3.component.css']
})
export class Page3Component implements OnInit {

  constructor(private stateService: StateService, private appService: AppService) {
    this.appService.pageTitle = 'Otentica - Companies';
  }

  ngOnInit(): void {
  }

  public getAllUsers(): User[] {
    return this.stateService.getAllUsers();
  }

  public shouldView(): (user: User) => boolean {
    let stateService: StateService = this.stateService;
    return (user: User) => {
      let currentUser: User = stateService.getCurrentUser();
      return currentUser.pendingAccess.indexOf(user.username) > -1
        || currentUser.activeAccess.indexOf(user.username) > -1;
    }
  }

  public accessRequested(user: User): boolean {
    let currentUser: User = this.stateService.getCurrentUser();
    return currentUser.pendingAccess.indexOf(user.username) > -1;
  }

  public accessGranted(user: User): boolean {
    let currentUser: User = this.stateService.getCurrentUser();
    return currentUser.activeAccess.indexOf(user.username) > -1;
  }

  public grantAccess(user: User): void {
    let currentUser: User = this.stateService.getCurrentUser();
    const index = currentUser.pendingAccess.indexOf(user.username);
    if (index > -1) {
      currentUser.pendingAccess.splice(index, 1);
    }
    currentUser.activeAccess.push(user.username);
  }

  public revokeAccess(user: User): void {
    let currentUser: User = this.stateService.getCurrentUser();
    const index = currentUser.activeAccess.indexOf(user.username);
    if (index > -1) {
      currentUser.activeAccess.splice(index, 1);
    }
  }

}
